window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    
    const groups = gsap.utils.toArray(".accordion-group");
    const menus = gsap.utils.toArray(".accordion-heading");
  
    menus.forEach((menu) => {
      menu.addEventListener("click", () => toggleMenu(menu));
    });
  
    const toggleMenu = (clickedMenu) => {
      menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
    };

    const createAnimation = (element) => {
      const menu = element.querySelector(".accordion-heading");
      const box = element.querySelector(".accordion-content");
      const icon = element.querySelector(".accordion-icon");
  
      gsap.set(box, {
      height: "auto",
      padding: "16px 0",
      boxSizing: "content-box",
    });
      gsap.set(icon, { transform: "rotate(45deg)" });
  
      const animation = gsap
        .from(box, {
          height: 0,
          padding: 0,
          duration: 0.2,
          ease: "power1.inOut",
        })
        .reverse();
  
      const iconAnim = gsap
        .from(icon, {
          transform: "rotate(0deg)",
          duration: 0.2,
        })
        .reverse();
  
      return (clickedMenu) => {
        if (clickedMenu === menu) {
          animation.reversed(!animation.reversed());
          iconAnim.reversed(!iconAnim.reversed());
        } else {
          animation.reverse();
          iconAnim.reverse();
        }
      };
    };
  
    const menuToggles = groups.map(createAnimation);
  }, 500);
});
